import rg4js from 'raygun4js';

//config
import configuration from 'configs/configuration';

export const init = () => {
  if (configuration.isProduction) {
    rg4js('apiKey', configuration.raygunApiKey);
    rg4js('enableCrashReporting', true);
  }
};

export const captureException = (exception, payload = {}) => {
  if (configuration.isProduction) {
    rg4js('send', { error: exception, ...payload });
  } else {
    // eslint-disable-next-line no-console
    console.log('%cError:', 'background-color: red; color: white; font-size: 12px', exception);
  }
};

export const setUser = user => {
  if (configuration.isProduction) {
    rg4js('setUser', {
      identifier: String(user.identifier),
      isAnonymous: false,
      email: user.email,
      fullName: user.fullName,
    });
    rg4js('withCustomData', { databaseName: user.databaseName });
  }
};

export const clearUser = () => {
  if (configuration.isProduction) {
    rg4js('withCustomData', {});
    rg4js('endSession');
  }
};
